import { Gift, Loader2, Printer } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { fmtDateTime } from "@/lib/datetime";

const money = (v) => `$${Number(v || 0).toFixed(2)}`;

// Comprobantes de cortesía del turno — reimpresión (no re-aplica ni mueve caja). Presentacional.
export const CortesiaComprobantesDialog = ({ open, onClose, cortesias = [], loading = false, onReimprimir }) => (
  <Dialog open={open} onOpenChange={(o) => !o && onClose?.()}>
    <DialogContent className="bg-[#0F0F0F] border-white/10 text-white sm:max-w-md max-h-[90dvh] overflow-y-auto overflow-x-hidden" data-testid="cortesia-comprobantes-modal">
      <DialogHeader>
        <DialogTitle className="font-display uppercase tracking-wider flex items-center gap-2"><Gift className="h-5 w-5 text-[#10B981]" /> Comprobantes de cortesía</DialogTitle>
      </DialogHeader>
      <div className="pt-1">
        <div className="text-[10px] uppercase tracking-wider font-bold text-white/50 mb-2">Cortesías del turno actual</div>
        {loading ? (
          <div className="flex items-center justify-center py-6"><Loader2 className="h-5 w-5 animate-spin text-white/40" /></div>
        ) : cortesias.length === 0 ? (
          <div className="text-xs text-white/40 py-3">Aún no hay cortesías aplicadas en este turno.</div>
        ) : (
          <div className="space-y-2 max-h-[60vh] overflow-y-auto">
            {cortesias.map((c) => (
              <div key={c.id} data-testid={`cortesia-row-${c.id}`} className="flex items-center gap-2 bg-white/5 border border-white/10 p-2">
                <div className="flex-1 min-w-0">
                  <div className="font-display text-sm text-white">{money(c.importe)} <span className="text-[10px] uppercase tracking-wider text-[#10B981]">Folio {c.folio}</span></div>
                  <div className="text-xs text-white/60 truncate">{c.motivo || "-"}</div>
                  <div className="text-[10px] text-white/40">{fmtDateTime(c.fecha)}{c.operador ? ` · ${c.operador}` : ""}</div>
                </div>
                <button onClick={() => onReimprimir?.(c)} data-testid={`cortesia-reimprimir-${c.id}`}
                  className="btn-hard h-9 px-3 bg-[#10B981]/15 border border-[#10B981]/50 text-[#10B981] text-[10px] font-bold uppercase tracking-wider flex items-center gap-1 hover:bg-[#10B981]/25 shrink-0">
                  <Printer className="h-3.5 w-3.5" /> Reimprimir
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </DialogContent>
  </Dialog>
);

export default CortesiaComprobantesDialog;
